<template>
  <section id="appointment-section">
    <div class="container">
      <message-banner :variant="messages.variant" :showBanner="messages.showMessage" :message="messages.message"/>
      <div class="row container-item-form" style="text-align: center; width: auto">
        <button
            type="button"
            class="button-section button-back btn"
            @click.prevent="backToDonationLocation"
        >
          <font-awesome-icon :icon="['fas', 'chevron-left']"/>
          <span>BACK</span>
        </button>
      </div>
      <div id="block-info-donation-site">
        <div id="container-page-title" style="display: flex">
          <h1>Appointment</h1>
        </div>
        <div class="information-donor-appointment">
          <p class="p-section">Selected Donation Location:</p>
          <div class="row container-item-form">
            <div class="container-input-form container-input-form-left col-sm-8">
              <label class="label-form-css" for="name-donation-location">Name:</label>
              <input
                  type="tel"
                  class="form-control input-form-css"
                  id="name-donation-location"
                  v-model.trim="profileDonationData.name"
                  disabled="disabled"
              >
            </div>
            <div class="container-input-form col-sm-4">
              <label class="label-form-css" for="date-donation-location">Date:</label>
              <input
                  type="tel"
                  class="form-control input-form-css"
                  id="date-donation-location"
                  name="date_appointment"
                  disabled="true"
                  v-model.trim="profileDonationData.date"
              >
            </div>
          </div>
          <div class="row container-item-form">
            <div class="container-input-form col-sm">
              <label class="label-form-css" for="address-donation-location">Address:</label>
              <input
                  type="tel"
                  class="form-control input-form-css"
                  v-bind:class="{'invalid-item':objInvalid.invalidPassword}"
                  id="address-donation-location"
                  name="address_appointment"
                  disabled="disabled"
                  v-model.trim="profileDonationData.address"
              >
            </div>
          </div>
        </div>
        <div
            id="menu-panel"
            style=""
            v-if="seenModalWalkIn"
        >
          <div class="row container-item-form">
            <div class="container-input-form container-input-form-left col-sm">
              <label class="label-form-css" for="approx_time">Please enter expected time of your arrival:</label>
              <input
                  type="text"
                  class="form-control input-form-css"
                  :class="{'invalid-item':objInvalid.invalidPassword}"
                  id="approx_time"
                  v-model.trim="walkInInformation.approxTime"
              >
            </div>
          </div>
          <div class="row container-item-form " style="text-align: center">
            <button
                type="button"
                class="button-section btn"
                id="btn-schedule"
                v-on:click="scheduleWalkin('')"
            >
              SCHEDULE
              <i class="fa fa-chevron-right" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
      <div id="block-select-time-apoitment">
        <p class="title-block" style="text-align: left; font-size: 1rem; font-weight: bold">
          {{ arrTablSelectTime.donorReminder }}</p>
        <table class="table table-bordered table-hover" id="tab-appointment-page"
               style=" width: 100%; table-layout: fixed;">
          <thead>
          <tr>
            <th
                v-for="(itemTablSelectTimeHead, indexTablSelectTimeHead) in arrTablSelectTime.header"
                :key="indexTablSelectTimeHead"
                scope="col"
                style="width: 100%; text-align: center"
            >
              {{ itemTablSelectTimeHead.title }}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr
              :class=" showRowWalkin ? '':'hide-walkin' "
          >
            <td class="time">
              <div class="slot-time">Walk In</div>
            </td>
            <td
                v-for="(itemRowWalkIn, indexRowWalkIn) in arrTablSelectTime.walkIn"
                :key="indexRowWalkIn"
                v-on:click="openModalWalkIn(seenModalWalkIn, indexRowWalkIn, Number(itemRowWalkIn.content))"
            >
              <div
                  class="slot enable hover-pointer"
                  :class="[
                      Number( itemRowWalkIn.content ) <= 0 ? 'emptySlot': 'fullSlot',
                       { displayOnly: disableSelectTimeAppointment },
                       { displayOnly: !arrTablSelectTime.visibilityAppointments },
                       { displaySheduled: profileDonationData.status.sheduled },
                  ]"
                  v-if="itemRowWalkIn.content !== null"
              >
                <div>
                  {{
                    typeof itemRowWalkIn.content === 'number' && Number(itemRowWalkIn.content) > 0
                      ? itemRowWalkIn.content + ' Appts Available'
                      : siteCustomizationData.messages.unavailable
                  }}
                </div>
              </div>
              <div
                  class="personal-information"
                  v-if="itemRowWalkIn.seeProcedure"
              >
                <button
                    :title="itemRowWalkIn.name"
                    class="btn btn-sm btn-link btn-appt"
                    type="button" data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    :disabled="changeTime"
                    @click="showDropdownActionAppoint = indexRowWalkIn"
                >
                  {{ itemRowWalkIn.name }}
                </button>
                <div
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuButton"
                    x-placement="top-start"
                    v-if="showDropdownActionAppoint === indexRowWalkIn"
                    style="position: absolute; transform: translate3d(0px, -98px, 0px); top: 0px; will-change: transform;"
                >
                  <button
                      class="dropdown-item item-delete"
                      v-on:click="changeTimeAppointment(itemRowWalkIn.idApp, arrTablSelectTime.idProfile, itemRowWalkIn.type)"
                  >
                    Change Time
                  </button>
                  <button
                      class="dropdown-item item-delete"
                      v-on:click="cancelDonorAppointment(itemRowWalkIn.idApp)"
                  >
                    Cancel
                  </button>
                </div>

              </div>
            </td>
          </tr>
          <tr
              v-for="(itemTablSelectTimeBody, indexTablSelectTimeBody) in arrTablSelectTime.bodyTable"
              :key="indexTablSelectTimeBody"
          >
            <td class="time">
              <div
                  class="slot-time"
                  v-on:click="clickAppointmentTime(indexTablSelectTimeBody)"
              >
                {{ indexTablSelectTimeBody }}
              </div>
              <div
                  class="personal-information"
                  v-if="timeClickTimeAppointment===indexTablSelectTimeBody"
              >
                <div
                    v-for="(itemProcedure, indexProcedure) in listProcedure"
                    :key="indexProcedure"
                >
                  <button
                      :disabled="
                        itemTablSelectTimeBody[itemProcedure.name].content === 0
                        || itemTablSelectTimeBody[itemProcedure.name].content === 'BlockedTime'
                      "
                      class="dropdown-item item-delete"
                      v-on:click="selectTimeAppointment(indexTablSelectTimeBody, itemProcedure.name)"
                  >
                    {{ itemProcedure.title }}
                  </button>

                </div>
              </div>
            </td>
            <td
                v-for="(itemRowTablSelectTimeBody, indexItemRowTablSelectTimeBody) in itemTablSelectTimeBody"
                :key="indexItemRowTablSelectTimeBody"
            >
              <div
                  class="slot enable hover-pointer"
                  :class="[
                      Number(itemRowTablSelectTimeBody.content) <= 0 ? 'emptySlot' : 'fullSlot',
                      { displayOnly: disableSelectTimeAppointment},
                      { displayOnly: !arrTablSelectTime.visibilityAppointments },
                  ]"
                  v-if="itemRowTablSelectTimeBody.content !== 'BlockedTime'"
                  v-on:click="selectTimeAppointment(indexTablSelectTimeBody, itemRowTablSelectTimeBody.type)"
              >
                <div>
                  {{
                    typeof itemRowTablSelectTimeBody.content === 'number' && Number(itemRowTablSelectTimeBody.content) > 0
                      ? itemRowTablSelectTimeBody.content + ' Appts Available'
                      : siteCustomizationData.messages.unavailable
                  }}
                </div>
              </div>
              <div
                  class="personal-information"
                  v-if="itemRowTablSelectTimeBody.seeProcedure"
              >
                <button
                    :title="itemRowTablSelectTimeBody.name"
                    class="btn btn-sm btn-link btn-appt"
                    type="button" data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    :disabled="changeTime"
                    v-on:click="showDropdownActionAppoint = showDropdownActionAppoint === indexTablSelectTimeBody + indexItemRowTablSelectTimeBody ? 0 : indexTablSelectTimeBody + indexItemRowTablSelectTimeBody"
                >
                  {{ itemRowTablSelectTimeBody.name }}
                </button>
                <div
                    class="dropdown-menu"
                    v-if="showDropdownActionAppoint === indexTablSelectTimeBody + indexItemRowTablSelectTimeBody"
                >
                  <button
                      class="dropdown-item item-delete"
                      v-if="itemRowTablSelectTimeBody.permissionToChange"
                      v-on:click="changeTimeAppointment(itemRowTablSelectTimeBody.idApp, arrTablSelectTime.idProfile, itemRowTablSelectTimeBody.type)"

                  >
                    Change Time
                  </button>
                  <button
                      class="dropdown-item item-delete"
                      v-on:click="rescheduleTimeAppointment(itemRowTablSelectTimeBody.idAppointment, arrTablSelectTime.idProfile, itemRowTablSelectTimeBody.type, indexItemRowTablSelectTimeBody)"
                  >
                    Reschedule
                  </button>
                  <button
                      class="dropdown-item item-delete"
                      v-on:click="cancelDonorAppointment(itemRowTablSelectTimeBody.idApp)"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <temporary-donor-registration
        v-if="seenTemporaryDonorInfo"
        :new-donor="dataRequestDonationLocation.newDonor"
        :appt-id="apptId"
        v-on:afterTemporaryRegistration="afterTemporaryRegistration"
    />
    <blocked-window
        v-if="seenBlockedSection"
        :blocked-information="blockedInformation"
        :profile-donation-data="profileDonationData"
        v-on:actionBlocked="actionBlockedWindow"
    />
    <confirmation-window
        v-if="seenAppointmentConfirmation"
        :profile-donation-data="profileDonationData"
        :time-appointment="timeAppointment"
        v-on:afterConfirmation="afterConfirmation"
    />
  </section>
</template>

<script>
import xlooLib from "../../../librarys/xlooLib";
import {mapState} from 'vuex';
import moment from 'moment-timezone';
import TemporaryDonorRegistration from "./temporaryDonorRegistration";
import BlockedWindow from "./blockedWindow";
import ConfirmationWindow from "./confirmationWindow";
import MessageBanner from "../../elements/messageBanner";

export default {
  name: "dbBookingAppointment",
  components: {
    ConfirmationWindow,
    BlockedWindow,
    TemporaryDonorRegistration,
    MessageBanner
  },
  data() {
    return {
      entryPoint: 'standard',
      seenModalWalkIn: false,
      seenTemporaryDonorInfo: false,
      seenBlockedSection: false,
      seenAppointmentConfirmation: false,
      disableSelectTimeAppointment: false,
      showDropdownActionAppoint: 0,
      timeClickTimeAppointment: false,
      changeTime: false,
      walkInInformation: {
        approxTime: '',
        typeProcedureWalkIn: '',
      },
      profileDonationData: {
        name: '',
        address: '',
        city: '',
        state: '',
        postalcode: '',
        date: '',
        idProfile: '',
        donorReminder: '',
        status: {sheduled: false},
      },
      arrProcedureWalkIn: '',
      arrTablSelectTime: [],
      showRowWalkin: false,
      objInvalid: {
        invalidPassword: false,
        invalidFirstName: false,
        invalidLastName: false,
        invalidDateBrith: false,
        invalidIdDonationOrDonor: false,
        invalidCell: false,
        invalidEmail: false,
        invalidHomePhone: false,
        invalidStreet: false,
        invalidCity: false,
        invalidState: false,
        invalidZip: false,
      },
      blockedInformation: {
        time: '',
        date: '',
        idProfile: '',
        type: '',
        days: '',
        schedule: '',
        apptId: '',
      },
      varBookingActions: {
        idAppChangeTime: false,
        varReschedule: false,
      },
      apptId: '',
      timeAppointment: '',
      cellDonor: null,
      messages: {
        showMessage: false,
        variant: 'danger',
        message: '',
      },
    }
  },
  computed: {
    ...mapState({
      auth: state => state.auth.authDonor,
      resData: state => state.donateBloodAppointments.dataCreateBookingTab.responseData,
      lat: state => state.donateBloodAppointments.dataRequestDonationLocation.lat,
      lng: state => state.donateBloodAppointments.dataRequestDonationLocation.lng,
      profileId: state => state.donateBloodAppointments.dataDonationLocation.profileId,
      idDonor: state => state.donorInformation.idDonor,
      smsOptOut: state => state.donorInformation.smsOptedOut,
      firstNameDonor: state => state.donorInformation.firstName,
      lastNameDonor: state => state.donorInformation.lastName,
      phoneMobileDonor: state => state.donorInformation.mobilePhone,
      siteCustomizationData: state => state.settingsAndCustomize.siteCustomizationData,
      siteSettingData: state => state.settingsAndCustomize.donorPortalSettings,
      dataRequestDonationLocation: state => state.donateBloodAppointments.dataRequestDonationLocation,
      urlSite: state => state.settingsAndCustomize.configurationSite.urlSite,
      entryPointStore: state => state.donateBloodAppointments.entryPoint,
      actionVariableDonateBlood: state => state.donateBloodAppointments.actionVariableDonateBlood,
    }),

    listProcedure: function (){
      let myListProcedure = []
      let vm = this
      if (typeof this.arrTablSelectTime.header !== "undefined"){
        Object.keys(this.arrTablSelectTime.header).forEach(function(element) {
          if (element !== 'time'){
            myListProcedure.push({
              name: vm.arrTablSelectTime.header[element].name,
              title: vm.arrTablSelectTime.header[element].title,
            })
          }
        });
      }
      return myListProcedure
    }
  },
  watch: {
    resData: function (val){
      if (val === ''){
        return
      }
      this.createArrTablSelectTime()
    },
  },
  async mounted() {
    if(this.entryPointStore !== 'standard') {
      this.entryPoint = this.entryPointStore
    } else {
      this.$store.commit('donateBloodAppointments/set_entryPoint', 'standard')
    }
    let sccThis = this
    this.$root.$on("checkAndDeleteTemporaryAppt", (deletedApptId) => {
      sccThis.checkAndDeleteTemporaryApptAction(deletedApptId);
    })
    this.$root.$emit("showSpinner");
    this.customStyle();
    const getData = this.$router.currentRoute.query
    if (typeof getData.idApp !== 'undefined') {
      this.entryPoint = 'manege'
      this.$store.commit('donateBloodAppointments/set_entryPoint', this.entryPoint)
      this.$store.commit('donateBloodAppointments/set_dataBookingAppointment', {apptId: getData.idApp})
      this.$store.commit('donateBloodAppointments/set_showPage', {
        triggerBookingAppointment: true,
        triggerDonationLocation: true,
      })
    }
    if (typeof getData.mobile_code !== 'undefined') {
      if (this.idDonor === '') {
        await this.$store.dispatch('donorInformation/SET_createTemporaryAccount')
      }
      this.entryPoint = 'mobileCode'
      this.$store.commit('donateBloodAppointments/set_entryPoint', this.entryPoint)
      this.$store.commit('donateBloodAppointments/set_dataBookingAppointment', {mobileCode: getData.mobile_code})
      this.$store.commit('donateBloodAppointments/set_showPage', {
        triggerBookingAppointment: true,
        triggerDonationLocation: true,
      })
    }
    if (typeof getData.temporaryLink !== 'undefined') {
      this.entryPoint = 'temporaryLink'
      this.$store.commit('donateBloodAppointments/set_entryPoint', this.entryPoint)
      this.$store.commit('donorInformation/set_idDonor', getData.donorId)
      if (this.idDonor !== '') {
        await this.$store.dispatch('donorInformation/SET_getDonorInformation', {idDonor: getData.donorId, appt: getData.apptIdTemporary})
      } else {
        this.messages.showMessage = true
        this.messages.variant = 'danger'
        this.messages.message = 'This link is not correct'
      }
      this.$store.commit('donateBloodAppointments/set_dataBookingAppointment', {apptId: getData.apptIdTemporary})
      this.$store.commit('donateBloodAppointments/set_dataDonationLocation', {
        lat: getData.lat,
        lng: getData.lng,
      })
      this.$store.commit('donateBloodAppointments/set_donationLocation', {eligibility: '',})

      this.$store.commit('donateBloodAppointments/set_showPage', {
        triggerBookingAppointment: true,
        triggerDonationLocation: true,
      })
    }
    const dataAppointmentsRequest = await this.$store.dispatch('donateBloodAppointments/SET_createBookingTab', {entryPoint: this.entryPoint})
    if (dataAppointmentsRequest?.error){
      this.errorAlert(dataAppointmentsRequest?.message);
      this.$root.$emit("hideSpinner")
      await this.$router.push({name: 'donateBlood'})
      return
    }
    this.maxReachedApp();
    this.profileDonationData.name = this.resData.data.form.profile.name
    this.profileDonationData.address = this.resData.data.form.profile.address_formated
    this.profileDonationData.city = this.resData.data.form.profile.address_city
    this.profileDonationData.state = this.resData.data.form.profile.address_state
    this.profileDonationData.postalcode = this.resData.data.form.profile.address_postalcode
    this.profileDonationData.date = moment(this.resData.data.form.profile.date, 'YYYY-MM-DD').format('MM/DD/YYYY')
    this.profileDonationData.idProfile = this.resData.data.form.profile.id
    this.arrTablSelectTime = this.createArrTablSelectTime();
    this.cellDonor = this.phoneMobileDonor

    this.disableSelectTimeAppointment = (this.entryPoint === 'temporaryLink') ? true : false

    this.varBookingActions.varReschedule = this.$store.getters["donateBloodAppointments/actionVariableDonateBlood"].varReschedule

    this.$root.$emit("hideSpinner");
  },
  beforeMount() {

  },
  methods: {
    customStyle() {
      document.getElementById('appointment-section').style.setProperty("--ColorButtonAppt", this.siteCustomizationData.appointmentsPage.colorAppointmentButton);
      document.getElementById('appointment-section').style.setProperty("--ColorFontButtonAppt", this.siteCustomizationData.appointmentsPage.colorFontAppointmentButton);
      document.getElementById('appointment-section').style.setProperty("--ManegeButtonApptColor", this.siteCustomizationData.appointmentsPage.colorManegeButton);
      document.getElementById('appointment-section').style.setProperty("--ManegeButtonFontApptColor", this.siteCustomizationData.appointmentsPage.colorFontManegeButton);
      document.getElementById('appointment-section').style.setProperty("--EmptySlotColor", this.siteCustomizationData.appointmentsPage.colorEmptyButton);
      document.getElementById('appointment-section').style.setProperty("--EmptySlotButtonFontColor", this.siteCustomizationData.appointmentsPage.colorFontEmptyButton);
    },

     maxReachedApp(){
      let arrBookingInf = this.resData.data.form;
      if (arrBookingInf.available.Total <= 0) {
        this.errorAlert('No More Appointments Available on This Day.')
        this.$root.$emit("hideSpinner")
        this.$router.push({name: 'donateBlood'})
      }
    },

    async backToDonationLocation() {
      if (this.entryPoint === 'manege') {
        await this.$router.push({name: 'myDonations'})
        return
      }
      await this.$router.push({name: 'dbChoiceDonationLocation'})
    },
    /*
        async openAppointment() {
          this.$root.$emit("showSpinner");
    //      const res_createBookingTab = await this.$store.dispatch('donateBloodAppointments/SET_createBookingTab')
     //     console.log('res_createBookingTab = ', res_createBookingTab)
          this.$root.$emit("hideSpinner");
        },

     */
    async actionBlockedWindow(data) {
      switch (data) {
        case 'reschedule':
          this.$root.$emit("showSpinner");
          this.$store.commit('donateBloodAppointments/set_dataDonationLocation', {profileId: this.blockedInformation.idProfile,})
          await this.$store.dispatch('donateBloodAppointments/SET_createBookingTab')
          this.$root.$emit("hideSpinner");
          break
      }
      this.seenBlockedSection = false;
    },
    afterTemporaryRegistration() {
      this.seenTemporaryDonorInfo = false
      this.seenAppointmentConfirmation = true
    },
    createArrTablSelectTime(/*arrStart*/) {
      let arrCreateBookingTab = this.resData.data.form;
      if (typeof arrCreateBookingTab === "undefined") {
        this.errorAlert('Error data');
        return
      }

      let arrTablSelectTime = {
        date: arrCreateBookingTab.profile.date,
        idProfile: arrCreateBookingTab.profile.id,
        donorReminder: arrCreateBookingTab.profile.donor_reminder,
        visibilityAppointments: false,
        header: {
          time: {
            name: 'time',
            title: 'Time',
          },
        },
        walkIn: {},
        bodyTable: {},
        showWalkin: true,
      };
      if (arrCreateBookingTab.profile.status == 'scheduled') {
        arrTablSelectTime.visibilityAppointments = true
      }
      // eslint-disable-next-line no-unused-vars
      let menageProcedure = (this.entryPoint === 'temporaryLink')
      if (this.entryPoint === 'temporaryLink') {
        if (arrCreateBookingTab.appointments.length != 0) {
          for (let $keyAppointments in arrCreateBookingTab.appointments) {
            if (this.firstNameDonor === arrCreateBookingTab.appointments[$keyAppointments].first_name && this.lastNameDonor === arrCreateBookingTab.appointments[$keyAppointments].last_name) {
              menageProcedure = arrCreateBookingTab.appointments[$keyAppointments].procedure_donation;
            }
          }
        }
      }
      if (this.entryPoint === 'manege' && this.actionVariableDonateBlood.varReschedule) {
        menageProcedure = this.actionVariableDonateBlood.varReschedule.typeProcedure
      }

      for (var itemTypes in arrCreateBookingTab.types) {
        if (!xlooLib.isEmptyObject(arrCreateBookingTab.procedures)) {
          for (var keyProcedures in arrCreateBookingTab.procedures) {
            if(arrCreateBookingTab.procedures[keyProcedures]?.max_proc_aptms_online === '0' && this.siteSettingData.hideZeroProcedures){
              continue
            }
            if (itemTypes == keyProcedures) {
              if (menageProcedure && menageProcedure !== keyProcedures){
                if (this.entryPoint === 'temporaryLink' || this.entryPoint === 'manege'){
                  continue;
                }
              }
              arrTablSelectTime.header[keyProcedures] = {
                name: keyProcedures,
                title: arrCreateBookingTab.types[itemTypes],
                icon: '',
                idProfile: arrCreateBookingTab.procedures[keyProcedures].id,
              }
              if (arrCreateBookingTab.walkin[keyProcedures].available > 0){
                this.showRowWalkin = true
              }
              arrTablSelectTime.walkIn[keyProcedures] = {
                content: arrCreateBookingTab.walkin[keyProcedures].available,
                hover: true
              }
              this.arrProcedureWalkIn = {
                [keyProcedures]: {
                  content: arrCreateBookingTab.types[itemTypes],
                  typeWalkin: keyProcedures,
                }
              }
              if (arrCreateBookingTab.tabl.length != 0) {
                for (var keyTabl in arrCreateBookingTab.tabl) {
                  if (arrCreateBookingTab.tabl[keyTabl][itemTypes].value == null || arrCreateBookingTab.tabl[keyTabl][itemTypes].inPast) {
                    if (arrTablSelectTime.bodyTable[arrCreateBookingTab.tabl[keyTabl].time] === undefined) {
                      arrTablSelectTime.bodyTable[arrCreateBookingTab.tabl[keyTabl].time] = {
                        [itemTypes]: {
                          content: 'BlockedTime',
                          hover: true,
                        }
                      }
                    } else {
                      arrTablSelectTime.bodyTable[arrCreateBookingTab.tabl[keyTabl].time][itemTypes] = {
                        content: 'BlockedTime',
                        hover: true,
                      }
                    }
                  } else {
                    if (arrTablSelectTime.bodyTable[arrCreateBookingTab.tabl[keyTabl].time] === undefined) {
                      arrTablSelectTime.bodyTable[arrCreateBookingTab.tabl[keyTabl].time] = {
                        [itemTypes]: {
                          content: arrCreateBookingTab.tabl[keyTabl][itemTypes].value,
                          type: itemTypes,
                          hover: true,
                        }
                      }
                    } else {
                      arrTablSelectTime.bodyTable[arrCreateBookingTab.tabl[keyTabl].time][itemTypes] = {
                        content: arrCreateBookingTab.tabl[keyTabl][itemTypes].value,
                        type: itemTypes,
                        hover: true,
                      }
                    }
                  }
                }
              }
            }

            if (arrCreateBookingTab.appointments.length != 0) {
              var dt = '';
              moment.locale('en')
              var fullName = '';
              var indexAppt = '';
              var dateIntermediate = '';
              for (var keyAppointments in arrCreateBookingTab.appointments) {
                indexAppt = arrCreateBookingTab.appointments[keyAppointments].procedure_donation;

                if (typeof arrTablSelectTime != 'undefined' && {}.propertyIsEnumerable.call(arrTablSelectTime, 'bodyTable')) {
                  fullName = arrCreateBookingTab.appointments[keyAppointments].first_name + ' ' + arrCreateBookingTab.appointments[keyAppointments].last_name;
                  if (
                      arrCreateBookingTab.appointments[keyAppointments].first_name == this.firstNameDonor
                      && arrCreateBookingTab.appointments[keyAppointments].last_name == this.lastNameDonor
                      && arrCreateBookingTab.appointments[keyAppointments].walkin != 1
                      && arrCreateBookingTab.appointments[keyAppointments].last_name != 'PORTAL_TEMPORARY'
                      && arrCreateBookingTab.appointments[keyAppointments].last_name != 'reservationApp'
                  ) {
                    dateIntermediate = arrCreateBookingTab.appointments[keyAppointments].date + 'T' + arrCreateBookingTab.appointments[keyAppointments].time;
                    dt = moment(dateIntermediate).format('LT');
                    if ((dt in arrTablSelectTime.bodyTable) && (indexAppt in arrTablSelectTime.bodyTable[dt])) {
                      arrTablSelectTime.bodyTable[dt][indexAppt].seeProcedure = true;
                      arrTablSelectTime.bodyTable[dt][indexAppt].name = fullName;
                      arrTablSelectTime.bodyTable[dt][indexAppt].idApp = arrCreateBookingTab.appointments[keyAppointments].id;
                      arrTablSelectTime.bodyTable[dt][indexAppt].idAppointment = arrCreateBookingTab.appointments[keyAppointments].appointment_id;
                      if (moment().isSame(arrCreateBookingTab.profile.date) && arrCreateBookingTab.profile.same_day_allowed) {
                        arrTablSelectTime.bodyTable[dt][indexAppt].permissionToChange = false;
                      } else {
                        arrTablSelectTime.bodyTable[dt][indexAppt].permissionToChange = true;
                      }
                    }
                  }
                  if (
                      arrCreateBookingTab.appointments[keyAppointments].first_name == this.firstNameDonor
                      && arrCreateBookingTab.appointments[keyAppointments].last_name == this.lastNameDonor
                      &&  this.lastNameDonor.toUpperCase() !== 'PORTAL_TEMPORARY'
                      &&  this.lastNameDonor.toUpperCase() !== 'reservationApp'
                      && arrCreateBookingTab.appointments[keyAppointments].walkin == 1
                  ) {
                    if ({}.propertyIsEnumerable.call(arrTablSelectTime, 'walkIn') && (indexAppt in arrTablSelectTime.walkIn)) {
                      if (!moment().isSame(arrCreateBookingTab.profile.date) && !arrCreateBookingTab.profile.same_day_allowed) {
                        arrTablSelectTime.walkIn[indexAppt] = {
                          seeProcedure: true,
                          permissionToChange: false,
                          name: fullName,
                          idApp: arrCreateBookingTab.appointments[keyAppointments].id,
                          idAppointment: arrCreateBookingTab.appointments[keyAppointments].appointment_id,
                        }
                      } else {
                        arrTablSelectTime.walkIn[indexAppt] = {
                          seeProcedure: true,
                          permissionToChange: true,
                          name: fullName,
                          idApp: arrCreateBookingTab.appointments[keyAppointments].id,
                          idAppointment: arrCreateBookingTab.appointments[keyAppointments].appointment_id,
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      /*
      * Delete slots that have Blocked Time for all procedures
      */
      const arrProceduresAndTime = Object.keys(arrTablSelectTime.header)
      let seeRow = false
      let emptySlot = true
      const nameProcedure = arrProceduresAndTime.filter(el => el !== 'time')
      Object.keys(arrTablSelectTime.bodyTable).forEach(key => {
        seeRow = false

        nameProcedure.forEach(proc => {
          emptySlot = arrTablSelectTime.bodyTable[key][proc].content === 'BlockedTime'

          if (!emptySlot) {
            seeRow = true
          }
        })

        if (!seeRow) {
          delete arrTablSelectTime.bodyTable[key]
        }
      })
      // check: show or not row Walk-in
/*      seeRow = false
      nameProcedure.forEach(proc => {
        if(arrTablSelectTime.walkIn[proc].content !== null) {
          seeRow = true
        }
      })*/

      return arrTablSelectTime;
    },
    selectTimeAppointment(time, type) {
      this.timeClickTimeAppointment = false

      if (this.disableSelectTimeAppointment || this.arrTablSelectTime.visibilityAppointments === false) {
        return
      }
      if (this.arrTablSelectTime.bodyTable[time][type].content == '0') {
        this.errorAlert('No Appointments');
        return
      }
      this.timeAppointment = time

      let params = {
        action: 'entryPoints',
        entryPoint: 'appointment_calendar',
        entryAction: 'bookingAppointment',
        profileId: this.profileDonationData.idProfile,
        donorId: this.idDonor === '' ? 'reservationApp' : this.idDonor,
        time: time,
        type: type,
        eligibility: this.dataRequestDonationLocation.eligibility,
      }
      if (params.donorId === 'reservationApp'){
        params.temporary = 1
      }
      if (this.varBookingActions.idAppChangeTime !== false) {
        params.apptId = this.varBookingActions.idAppChangeTime
        params.appt = ''
        this.varBookingActions.idAppChangeTime = false
        this.disableSelectTimeAppointment = false
      } else {
        if (this.varBookingActions.varReschedule !== false) {
          params.apptId = ''
          if (typeof this.varBookingActions.varReschedule.idApp !== 'undefined') {
            params.idAppThatRe = this.varBookingActions.varReschedule.idApp
          } else {
            console.log('error: not idApp for reschedule ')
          }

          this.varBookingActions.varReschedule = false
          this.$store.commit('donateBloodAppointments/set_actionVariableDonateBlood', {varReschedule: this.varBookingActions.varReschedule})
        } else {
          params.apptId = ''
          params.apptIdRe = ''
        }
      }
      this.actionSelectTimeAppointment(params)
    },
    async actionSelectTimeAppointment(params) {
      this.$root.$emit("showSpinner")
      let bookingRequest = await this.$store.dispatch('donateBloodAppointments/SET_bookingRequest', params)
      this.$root.$emit("hideSpinner")

      if (typeof bookingRequest.blocked != 'undefined') {
        this.blockedInformation.time = bookingRequest.appts[0].time;
        this.blockedInformation.date = moment(bookingRequest.appts[0].date).format("MM/DD/YYYY");
        this.blockedInformation.idProfile = bookingRequest.appts[0].calendar_profile_id;
        this.blockedInformation.type = bookingRequest.appts[0].procedure_donation;
        this.blockedInformation.days = bookingRequest.blocked;
        this.blockedInformation.schedule = moment().isSameOrBefore(this.blockedInformation.date);
        this.blockedInformation.apptId = bookingRequest.appts[0].id
        this.seenBlockedSection = true
      } else {
        if(typeof bookingRequest.status != 'undefined'){
          if(bookingRequest.status === 'error'){
            return;
          }
        }
        if (typeof bookingRequest.apptId === "undefined" || bookingRequest?.apptId === ''){
          if ( bookingRequest?.message === 'Not Available'){
            this.errorAlert('The time slot you selected was just booked by another donor. Please select a different time or date for your donation.')
          } else {
            alert('Appointment was not created. Try again or call to Donation Location.')
          }
          return
        }

        this.changeTime = false;
        this.changeTimeAppId = '';
        this.apptId = bookingRequest.apptId

        if (!this.auth && (this.entryPointStore !== 'manege' && this.entryPoint !=='temporaryLink')){
          this.seenTemporaryDonorInfo = true;
          this.$store.commit('donorInformation/set_lastName', '')
        } else {
          this.seenAppointmentConfirmation = true;
        }
      }
    },
    async afterConfirmation() {
      console.log('smsOptOut  Booking appointment == ', this.smsOptOut)
      let dataConfirmationOk = {
        action: 'entryPoints',
        entryPoint: 'appointment_calendar',
        entryAction: 'bookingConfirming',
        phone: xlooLib.phoneCleaner(this.phoneMobileDonor),
        apptId: this.apptId,
        donorId: this.idDonor,
        notify: this.smsOptOut ? '0' : '1',
        url: this.urlSite + 'donate-blood/booking-appointment/?temporaryLink=1&apptIdTemporary=' + this.apptId
            + '&donorId=' + this.idDonor + '&lat=' + this.lat + '&lng=' + this.lng,
      }

      this.$root.$emit("showSpinner")
      await this.$store.dispatch('donateBloodAppointments/SET_confirm', dataConfirmationOk)
      this.$root.$emit("hideSpinner")

      if (this.auth) {
        this.$router.push({name: 'myDonations'})
      } else {
        this.$router.push({name: 'home'})
      }
    },
    changeTimeAppointment(idApp, idProfile, type) {
      this.varBookingActions.idAppChangeTime = idApp
      this.showDropdownActionAppoint = 0
      let dataChangeTime = {
        action: 'entryPoints',
        entryPoint: 'appointment_calendar',
        entryAction: 'bookingForm',
        profileId: idProfile,
        type: type,
        eligibility: this.dataRequestDonationLocation.eligibility,
        apptIdEdit: idApp,
        apptId: '',
        nobooking: '',
        donorId: this.idDonor,
      };
      this.changeTimeAppId = idApp
      // eslint-disable-next-line no-unused-vars
      const resChangeTime = this.$store.dispatch('donateBloodAppointments/SET_changeTimeAppointment', dataChangeTime)
      this.changeTime = true
      this.disableSelectTimeAppointment = false
      this.changeTimeAppId = idApp  //????? is it necessary
    },
    async cancelDonorAppointment(idApp) {
      if (!confirm('Are you sure you want to cancel your appointment?')) {
        return
      }

      this.$root.$emit("showSpinner");
      this.showDropdownActionAppoint = 0

      const res_canceling = await this.$store.dispatch('donateBloodAppointments/SET_cancelingDonorAppointment', idApp)

      this.$root.$emit("hideSpinner");

      if (!res_canceling){
        this.errorAlert('Sorry, we were unable to cancel your appointment. Please contact your administrator');
        return
      }
//      this.createArrTablSelectTime()
      this.$router.push({name: 'myDonations'})
    },
    rescheduleTimeAppointment(idApp, idProfile, typeProcedure) {
      this.showDropdownActionAppoint = 0
      this.varBookingActions.varReschedule = {idApp: idApp, idProfile: idProfile}
      this.$store.commit('donateBloodAppointments/set_actionVariableDonateBlood', {varReschedule: this.varBookingActions.varReschedule})
      this.$router.push({
        name: 'dbChoiceDonationLocation',
        query: {
          idApp: idApp,
          idProfile: idProfile,
          typeProcedure: typeProcedure,
        }
      })
    },
    openModalWalkIn(seenModalWalkIn, type, content) {
      if (content === 0) {
        this.$root.$emit('messageBox',
            {
              timeShow: 2000,
              typeColor: "danger",
              textMessage: "No Appointments.",
            })
        return
      }
      if (this.disableSelectTimeAppointment) {
        return
      }
      this.walkInInformation.typeProcedureWalkIn = type;
      this.seenModalWalkIn = !this.seenModalWalkIn
    },
    scheduleWalkin() {
      let apptId = this.changeTimeAppId !== '' ? this.changeTimeAppId : ''
      if (typeof apptId === 'undefined') {
        apptId = ''
      }
      const params = {
        action: 'entryPoints',
        entryPoint: 'appointment_calendar',
        entryAction: 'bookingAppointment',
        profileId: this.profileDonationData.idProfile,
        donorId: this.idDonor === '' ? 'reservationApp' : this.idDonor,
        time: 'WalkIn',
        type: this.walkInInformation.typeProcedureWalkIn,
        eligibility: this.dataRequestDonationLocation.eligibility,
        apptId: apptId,
        approxTime: this.walkInInformation.approxTime,
      }
      if (params.donorId === 'reservationApp'){
        params.temporary = 1
      }
      this.actionSelectTimeAppointment(params)
    },
    async checkAndDeleteTemporaryApptAction(idApp) {
      this.$root.$emit("showSpinner")
      await this.$store.dispatch('donateBloodAppointments/SET_cancelingTemporaryDonorAppointment', idApp)
      this.$root.$emit("hideSpinner")

      this.seenTemporaryDonorInfo = false
    },
    clickAppointmentTime(time){
      if (Object.keys(this.arrTablSelectTime.header).length<=2){
        let vm = this
        Object.keys(this.arrTablSelectTime.header).forEach(key=>{
          if(key !=='time'){
            vm.selectTimeAppointment(time, vm.arrTablSelectTime.header[key].name)
          }
        })
        return
      }
      if (!this.timeClickTimeAppointment && Object.keys(this.arrTablSelectTime.header).length>2){
        this.timeClickTimeAppointment = time
      } else {
        this.timeClickTimeAppointment = false
      }
    },
    errorAlert(message){
      this.$root.$emit('messageBox',
          {
            timeShow: 0,
            typeColor: "danger",
            textMessage: message,
          })
    }
  },
}
</script>

<style scoped>
#appointment-section {
  --ColorButtonAppt: #BFEFA4;
  --ColorFontButtonAppt: #000;
  --ManegeButtonApptColor: #DAFAEC;
  --ManegeButtonFontApptColor: #000;
  --EmptySlotColor: #fff;
  --EmptySlotButtonFontColor: #000;
}
.information-donor-appointment .row.container-item-form {
  max-width: 100%;
}
.information-donor-appointment .row .container-input-form {
  margin-bottom: 10px;
}
.p-section {
  text-align: start;
}

#block-info-donation-site {
  position: sticky;
  top: 0;
  background: #fff;
  min-height: 265px;
  z-index: 101;
}

#tab-appointment-page {
  width: 100%;
  text-align: center;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
}

.enable, .enable-walkin {
  border: 1px solid #aaa;
  border-radius: 0.25rem;
  cursor: pointer;
  background-color: var(--ColorButtonAppt);
  color: var(--ColorFontButtonAppt);
}

#tab-appointment-page th:first-child, #tab-appointment-page td:first-child {
  border-left: 1px solid #dee2e6;
}

#tab-appointment-page tr th {
  z-index: 1;
}

#tab-appointment-page th {
  border-top: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
  position: sticky;
  top: 265px;
  background: #fff;
}

#tab-appointment-page th:first-child, #tab-appointment-page td:first-child {
  border-left: 1px solid #dee2e6;
}

#tab-appointment-page td {
  border-bottom: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
}

.displayOnly {
  background-color: var(--ManegeButtonApptColor);
  color: var(--ManegeButtonFontApptColor);
}

.displayOnly:hover {
  cursor: default;
}

.personal-information {
  position: relative;
}

.dropdown-menu {
  position: absolute;
  left: calc(50% - 80px);
  display: block;
}
.hide-walkin{
  display: none;
}
</style>
